import React from 'react'
import { Typography } from '@mui/material'
import { useDeleteWebhookMutation } from 'src/services/integration-service'
import toast from 'react-hot-toast'
import DeleteDialog from '../../components/DeleteDialog'

const DeleteWebhookDialog = ({
  openDeleteModal,
  setOpenDeleteModal,
  setIntegration,
  webhookIdToDelete,
  setWebhookIdToDelete,
  webhookIdToDeleteName
}) => {
  const [deleteWebhook] = useDeleteWebhookMutation()

  const handleConfirmDelete = async (id) => {
    setIntegration(true)
    setOpenDeleteModal(false)
    const toastId = toast?.loading('Deleting webhook...', { duration: Infinity })
    try {
      const { message } = await deleteWebhook(webhookIdToDelete).unwrap()
      toast.success(message, { id: toastId, duration: 2000 })
    } catch (error) {
      toast.error('Failed to delete webhook', { id: toastId, duration: 2000 })
    }
    setIntegration(false)
  }

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false)
    setWebhookIdToDelete(null)
  }

  return (
    <DeleteDialog
      handleDeleteUser={handleConfirmDelete}
      open={openDeleteModal}
      onClose={handleCloseDeleteModal}
      header='Confirmation'
      title={
        <>
          You are about to permanently delete the connection with the webhook{' '}
          <Typography component='span' sx={{ fontWeight: 700 }}>
            {webhookIdToDeleteName}
          </Typography>
          .
        </>
      }
      subtitle='This action cannot be undone'
    />
  )
}

export default DeleteWebhookDialog